module.exports = __webpack_public_path__ + "img/xiezideren@3x.cc55060a.png";